var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createReducer } from '@reduxjs/toolkit';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { notificationActions } from '../actions/notification';
const { notificationDesktopPermissionSucceeded, notificationDesktopPermissionFailed, notificationAdded, notificationRemoveInStateById, notificationRemoveAllById, notificationRemoveInStateByType, notificationRatingAdded, notificationHistoryReset, notificationHistoryAdd, notificationTabBadgeShow, notificationTabBadgeReset, notificationGetPersistedSucceeded, notificationUpdate, } = notificationActions;
// Init state for the Notification.
export const initialState = {
    ui: {
        showBadge: false,
    },
    meta: {
        desktopPermission: false,
    },
    currentNotifications: [],
    notificationsHistory: [],
    persistedNotifications: [],
    ratingNotificaions: [],
};
const notifications = createReducer(initialState, (builder) => {
    builder
        .addCase(notificationUpdate, (state, action) => {
        const { patch: { updates, deletes }, id, } = action.payload;
        const notificationIndex = state.currentNotifications.findIndex((currentNotification) => currentNotification.id === id);
        if (notificationIndex === -1) {
            return;
        }
        if (updates) {
            const { time } = updates, restUpdates = __rest(updates, ["time"]);
            state.currentNotifications[notificationIndex] = merge(state.currentNotifications[notificationIndex], restUpdates);
            if (time) {
                const unixTime = new Date().getTime();
                state.currentNotifications[notificationIndex] = merge({}, state.currentNotifications[notificationIndex], {
                    startTime: time,
                    shouldBeRemovedAt: unixTime + time,
                });
            }
        }
        if (deletes) {
            state.currentNotifications[notificationIndex] = omit(state.currentNotifications[notificationIndex], deletes);
        }
    })
        .addCase(notificationTabBadgeShow.toString(), (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { showBadge: true }) });
    })
        .addCase(notificationTabBadgeReset.toString(), (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { showBadge: false }) });
    })
        .addCase(notificationDesktopPermissionSucceeded.toString(), (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { desktopPermission: true }) });
    })
        .addCase(notificationDesktopPermissionFailed.toString(), (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { desktopPermission: false }) });
    })
        .addCase(notificationAdded.toString(), (state, action) => {
        const { notification: newNotification } = action.payload;
        let currentNotifications = state.currentNotifications;
        const notificationIndex = currentNotifications.findIndex((currentNotification) => currentNotification.id === newNotification.id);
        if (newNotification.showInpage === true) {
            if (notificationIndex !== -1) {
                // notifications should be unique by id
                currentNotifications = currentNotifications.map((currentNotification, index) => index === notificationIndex
                    ? newNotification
                    : currentNotification);
            }
            else {
                currentNotifications = [...currentNotifications, newNotification];
            }
        }
        return Object.assign(Object.assign({}, state), { currentNotifications });
    })
        .addCase(notificationHistoryAdd.toString(), (state, action) => {
        var _a;
        const { notification } = action.payload;
        let notificationsHistory = state.notificationsHistory;
        // We do not save new message notifications.
        if (((_a = notification.type) === null || _a === void 0 ? void 0 : _a.indexOf('new-message-')) > -1) {
            return state;
        }
        const notificationIndex = notificationsHistory.findIndex((historyNotification) => historyNotification.id === notification.id);
        const newNotification = Object.assign({}, notification, {
            showInDropdown: true,
        });
        if (notification.showInpage === true ||
            notification.showDesktop === true) {
            if (notificationIndex !== -1) {
                // notifications should be unique by id
                notificationsHistory = notificationsHistory.map((historyNotification, index) => index === notificationIndex
                    ? newNotification
                    : historyNotification);
            }
            else {
                notificationsHistory = [...notificationsHistory, newNotification];
            }
        }
        return Object.assign(Object.assign({}, state), { notificationsHistory });
    })
        .addCase(notificationHistoryReset.toString(), (state) => {
        const notificationsHistory = state.notificationsHistory;
        const historyNotification = [];
        for (const n of notificationsHistory) {
            historyNotification.push(Object.assign({}, n, { showInDropdown: false, unseen: false }));
        }
        return Object.assign(Object.assign({}, state), { notificationsHistory: historyNotification });
    })
        .addCase(notificationRemoveInStateById.toString(), (state, action) => {
        const { id } = action.payload;
        if (id) {
            return Object.assign(Object.assign({}, state), { currentNotifications: state.currentNotifications.filter((n) => n.id !== id), ratingNotificaions: state.ratingNotificaions.filter((n) => n.id !== id) });
        }
        return state;
    })
        .addCase(notificationRemoveAllById.toString(), (state, action) => {
        const { id } = action.payload;
        if (id) {
            return Object.assign(Object.assign({}, state), { currentNotifications: state.currentNotifications.filter((n) => n.id !== id), ratingNotificaions: state.ratingNotificaions.filter((n) => n.id !== id), notificationsHistory: state.notificationsHistory.filter((n) => n.id !== id) });
        }
        return state;
    })
        .addCase(notificationRemoveInStateByType.toString(), (state, action) => {
        const { type } = action.payload;
        if (type) {
            return Object.assign(Object.assign({}, state), { currentNotifications: state.currentNotifications.filter((n) => n.type !== type) });
        }
        return state;
    })
        .addCase(notificationRatingAdded.toString(), (state, action) => {
        const { notification: newNotification } = action.payload;
        let ratingNotificaions = state.ratingNotificaions;
        const notificationIndex = ratingNotificaions.findIndex((ratingNotification) => ratingNotification.id === newNotification.id);
        if (newNotification.showInpage === true) {
            if (notificationIndex !== -1) {
                // notifications should be unique by id
                ratingNotificaions = ratingNotificaions.map((ratingNotification, index) => index === notificationIndex
                    ? newNotification
                    : ratingNotification);
            }
            else {
                ratingNotificaions = [...ratingNotificaions, newNotification];
            }
        }
        return Object.assign(Object.assign({}, state), { ratingNotificaions });
    })
        .addCase(notificationGetPersistedSucceeded.toString(), (state, action) => {
        const { payload: { data }, } = action;
        const { notifications } = data;
        const persistedNotifications = notifications
            .map((notification) => {
            try {
                return {
                    notificationId: notification.notification_id,
                    createdAt: notification.created_at,
                    isRead: notification.is_read,
                    data: JSON.parse(notification.payload),
                };
            }
            catch (error) {
                console.warn('Could not parse notification payload', error);
                return false;
            }
        })
            .filter(Boolean);
        const bulkIds = persistedNotifications.map((notification) => notification.data.params.bulk_id);
        const localNotifications = state.notificationsHistory.filter((local) => bulkIds.indexOf(local.id) === -1);
        return Object.assign(Object.assign({}, state), { persistedNotifications, notificationsHistory: localNotifications });
    });
});
export default notifications;
